module.exports = __webpack_public_path__ + "img/add-db.7dd9ac59.svg";